import { VAT_RATES_PER_COUNTRY } from '../../shared/constants.js'

const getVatRateSelectOptionsFromArray = (optionsArray = []) =>
  optionsArray.map(option => ({ label: `${option}%`, value: option }))

const getVatRateSelectOptionsForAllCountries = () =>
  Object.entries(VAT_RATES_PER_COUNTRY).reduce(
    (vatRateSelectOptions, [country, vatRates]) => {
      vatRateSelectOptions[country] = getVatRateSelectOptionsFromArray(vatRates)
      return vatRateSelectOptions
    },
    {}
  )

export {
  getVatRateSelectOptionsForAllCountries,
  getVatRateSelectOptionsFromArray
}
